import React from "react"
import clsx from "clsx"

export type MenuType = {
    title: string,
    icon: any,
    component: (data: any, cb?: (val: any) => void) => React.ReactNode,
}

type VerticalMenuProps = {
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    navMenu: MenuType[]
}

export function VerticalMenu({navMenu, activeIndex, setActiveIndex}: VerticalMenuProps) {


    return <nav className="space-y-1">
        {navMenu.map((item, index) => (
            <span
                key={item.title}
                onClick={() => {
                    setActiveIndex(index)
                }}
                className={clsx(
                    activeIndex === index
                        ? "border-blue-500 bg-blue-50 text-blue-700 hover:bg-blue-50 hover:text-blue-700"
                        : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                    "group flex items-center border-l-4 px-3 py-2 text-sm font-medium cursor-pointer"
                )}
            >
    <item.icon
        className={clsx(
            activeIndex === index
                ? "text-blue-500 group-hover:text-blue-500"
                : "text-gray-400 group-hover:text-gray-500",
            "-ml-1 mr-3 h-6 w-6 flex-shrink-0"
        )}
        aria-hidden="true"
    />
    <span className="truncate">{item.title}</span>
        </span>
        ))}
    </nav>
}